{ logoDomain, siteDomain } = require '@trello/config'
Auth = require 'app/scripts/db/auth'
t = require('./teacup-with-helpers')()
_ = require 'underscore'

methods =
  mustacheRenderWithHelpers: (body, data, opts = {}, partials = {}) ->
    args = _.extend {
      __ed: opts.editable
      __own: opts.owned
      __loggedIn: Auth.isLoggedIn()
      __siteDomain: siteDomain
      __logoDomain: logoDomain
    }, data

    t.mustacheRender body, args, partials

  mustacheRenderModel: (body, model, data, partials = {}) ->
    opts = { editable: model.editable?(), owned: model.owned?() }
    data = _.extend(model.toJSON(), data)
    methods.mustacheRenderWithHelpers body, data, opts, partials

  fill: (template, data = {}, opts = {}, partials = {}) ->
    if typeof template == 'string'
      throw new Error("You must now pass in an actual template, not a string. This makes our dependency tree more correct. The template we received was '#{template}'")
    methods.mustacheRenderWithHelpers(template, data, opts, partials)

  fillFromModel: (template, model, data = {}, partials = {}) ->
    if typeof template == 'string'
      throw new Error("You must now pass in an actual template, not a string. This makes our dependency tree more correct. The template we received was '#{template}'")
    methods.mustacheRenderModel(template, model, data, partials)

  fillMenu: (template, data, opts) ->
    methods.fill require('app/scripts/views/templates/menu_base'), { content: @fill(template, data, opts) }

module.exports = methods
